import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StoreItemResponse } from '@joc/api-gateway';
import { API } from '../../../core/API';
import { STORE_ITEMS_QUERY_KEY } from '../../../core/constants';

interface IUseFeaturedStoreItem {
	// eslint-disable-next-line no-unused-vars
	setFeaturedStoreItem: ({ id }: { id: number }) => void;
	isError: boolean;
	isSuccess: boolean;
	data?: StoreItemResponse;
}

interface IUseChangeFeaturedStoreItem {
	// eslint-disable-next-line no-unused-vars
	changeFeaturedStoreItem: ({ prevId, nextId }: { prevId: number; nextId: number }) => void;
	isError: boolean;
	isSuccess: boolean;
	data?: StoreItemResponse;
}

const featuredStoreItemApi = async (id: number) => {
	return API.setFeaturedItem(id);
};

export const useFeaturedStoreItem = (): IUseFeaturedStoreItem => {
	const queryClient = useQueryClient();
	const {
		mutate: setFeaturedStoreItem,
		data,
		isError,
		isSuccess,
	} = useMutation<StoreItemResponse, Error, { id: number }>({
		mutationFn: ({ id }) => featuredStoreItemApi(id),
		onSettled: () => queryClient.invalidateQueries({ queryKey: [STORE_ITEMS_QUERY_KEY] }),
	});

	return { setFeaturedStoreItem, data, isError, isSuccess };
};

export const useChangeFeaturedStoreItem = (): IUseChangeFeaturedStoreItem => {
	const queryClient = useQueryClient();
	const {
		mutate: changeFeaturedStoreItem,
		data,
		isError,
		isSuccess,
	} = useMutation<StoreItemResponse, Error, { prevId: number; nextId: number }>({
		mutationFn: async ({ prevId, nextId }) => {
			await featuredStoreItemApi(prevId);
			return featuredStoreItemApi(nextId);
		},
		onSettled: () => queryClient.invalidateQueries({ queryKey: [STORE_ITEMS_QUERY_KEY] }),
	});

	return { changeFeaturedStoreItem, data, isError, isSuccess };
};
